<template>
  <div class="screen">
    <h2>No Thanks!</h2>
    <p class="counter-band">
      Take the card, or pay a counter to push it to the next player. Lowest
      score wins — and in a run of consecutive numbers, only the lowest card
      counts against you.
    </p>

    <div class="field">
      <label for="player-name">Your name</label>
      <input
        id="player-name"
        v-model="name"
        maxlength="16"
        autocomplete="off"
        spellcheck="false"
      />
    </div>

    <div class="field">
      <label>Opponents</label>
      <div class="segmented">
        <button
          v-for="n in opponentChoices"
          :key="n"
          :class="{ 'is-selected': n === opponents }"
          @click="opponents = n"
        >{{ n }}</button>
      </div>
      <span class="counter-band">
        {{ opponents + 1 }} players · {{ countersEach }} counters each
      </span>
    </div>

    <!-- House rule, not the rulebook (constants.js, MAX_ROUNDS): play
         several rounds and add the scores up. One round is the real game. -->
    <div class="field">
      <label>Rounds</label>
      <div class="segmented">
        <button
          v-for="n in roundChoices"
          :key="n"
          :class="{ 'is-selected': n === rounds }"
          @click="rounds = n"
        >{{ n }}</button>
      </div>
      <span class="counter-band">
        {{ rounds === 1 ? 'One game, lowest score wins' : `Lowest total after ${rounds} rounds wins` }}
      </span>
    </div>

    <button class="primary" @click="start">Deal</button>
    <button v-if="hasSavedGame" class="secondary" @click="resume">
      Resume saved game
    </button>
    <button class="secondary" @click="$emit('play-online')">
      Play with friends online
    </button>

    <!-- The way home. Matt: "From the game lobby, I need a way to get back
         to... the main lobby." Same mark and wording in every game; the
         icon is the hub's own ring-of-seats logo. -->
    <MyStatsPanel />
    <LeaderBoard />

    <a class="hub-link" href="https://aroundtableround.com/" title="All the games">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.4" opacity="0.5" />
        <circle cx="20" cy="12" r="1.7" fill="currentColor" /><circle cx="17.66" cy="17.66" r="1.7" fill="currentColor" />
        <circle cx="12" cy="20" r="1.7" fill="currentColor" /><circle cx="6.34" cy="17.66" r="1.7" fill="currentColor" />
        <circle cx="4" cy="12" r="1.7" fill="currentColor" /><circle cx="6.34" cy="6.34" r="1.7" fill="currentColor" />
        <circle cx="12" cy="4" r="1.7" fill="currentColor" /><circle cx="17.66" cy="6.34" r="1.7" fill="currentColor" />
      </svg>
      Around Table Round
    </a>

      <!-- The install offer lives HERE, on the menu, and nowhere else.
           Matt: "the install button should only appear on the hub for each
           game... make sure it's not interfering with anything else. It's not
           a main use case." It used to be mounted in App.vue and fixed to the
           top-right corner of every screen, mid-game included. -->
    <InstallPrompt />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import InstallPrompt from '@/components/shared/InstallPrompt.vue';
import MyStatsPanel from '@/components/shared/MyStatsPanel.vue';
import LeaderBoard from '@/components/shared/LeaderBoard.vue';
import {
  MIN_PLAYERS, MAX_PLAYERS, MIN_ROUNDS, MAX_ROUNDS, countersForPlayerCount,
} from '@/engine/constants';

export default {
  name: 'NewGame',
  components: { InstallPrompt, MyStatsPanel, LeaderBoard },
  emits: ['play-online'],
  data() {
    return {
      name: this.$store.state.settings.playerName || 'You',
      opponents: this.$store.state.settings.opponents || 3,
      rounds: this.$store.state.settings.rounds || 1,
    };
  },
  computed: {
    ...mapState(['hasSavedGame']),
    // 3-7 players total (p1 header), and one seat is always the human.
    opponentChoices() {
      const choices = [];
      for (let total = MIN_PLAYERS; total <= MAX_PLAYERS; total += 1) choices.push(total - 1);
      return choices;
    },
    roundChoices() {
      const choices = [];
      for (let n = MIN_ROUNDS; n <= MAX_ROUNDS; n += 1) choices.push(n);
      return choices;
    },
    countersEach() {
      return countersForPlayerCount(this.opponents + 1);
    },
  },
  methods: {
    start() {
      this.$store.dispatch('newGame', {
        playerName: this.name.trim() || 'You',
        opponents: this.opponents,
        rounds: this.rounds,
      });
    },
    resume() {
      this.$store.dispatch('resumeGame');
    },
  },
};
</script>
